import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M7.62305 6C7.29182 6.00026 7.02344 6.26929 7.02344 6.60059V17.3994C7.02344 17.7307 7.29182 17.9997 7.62305 18C7.9545 18 8.22363 17.7309 8.22363 17.3994V6.60059C8.22363 6.26914 7.9545 6 7.62305 6ZM16.7568 6.66992C16.464 6.37725 15.9891 6.37715 15.6963 6.66992L11.249 11.1162L11.1631 11.2109C10.7895 11.6691 10.7895 12.3309 11.1631 12.7891L11.249 12.8838L15.6963 17.3311C15.9891 17.6238 16.464 17.6227 16.7568 17.3301C17.0497 17.0371 17.0498 16.5624 16.7568 16.2695L12.4863 12L16.7568 7.73047C17.0498 7.43761 17.0497 6.96285 16.7568 6.66992Z" }, null, -1)
  ]))]))
}
export default { render: render }